import { Typography } from "@mui/material"
import { t } from "i18next"
import { Trans } from "react-i18next"
import "@reactour/popover/dist/index.css"
import { theme } from "themes/default/theme"

import { popoverStyles } from "components/ActivityContent/styles/GetStarted.styles"
import GetStartedBuble from "components/GetStarted/GetStartedBuble"

export const nextStyles = {
  minWidth: 0,
  alignSelf: "flex-end",
  textTransform: "none",
  fontSize: "0.75rem",
  position: "absolute",
  bottom: -30,
  right: 0,
  backgroundColor: theme.palette.common.white,
  color: "#2d2d2d",
  border: `1px solid #ccc`,
  borderRadius: "3px",
  padding: "2px 22px",
  textShadow: `1px 1px 0 #fff`,
  font: `12px/normal sans-serif`,
  outline: 0,
  zoom: 1,
  lineHeight: 1.3,
  "&:hover": {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  "& svg": {
    width: 20,
    height: 20,
    fontSize: 16,
  },
}

export const gradeBarSteps = (onNext) => {
  return [
    {
      id: "gradeBar",
      selector: ".exercise-grade",
      highlightedSelectors: [".exercise-grade"],
      mutationObservables: [".exercise-grade"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="this_is_the_grade_for_this_exercise"
          onNextClick={() => setCurrentStep(currentStep + 1)}
          audioLink="this_is_the_grade_for_this_exercise"
          showAudio
          showNextButton
          showImage
          forceShow
          image={17}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "top",
      showBadge: true,
      styles: popoverStyles,
    },
    {
      id: "gradeBar",
      selector: ".exercises",
      highlightedSelectors: [".exercises"],
      mutationObservables: [".exercises"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="there_are_n_exercises_here"
          onNextClick={() => setCurrentStep(currentStep + 1)}
          audioLink="there_are_n_exercises_here"
          showAudio
          showNextButton
          showBackButton
          onBackClick={() => setCurrentStep(currentStep - 1)}
          showImage
          forceShow
          customImageStyle={{
            top: -210,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "left",
      styles: {
        popover: (base, state) => ({
          ...popoverStyles.popover(base, state),
          top: -36,
        }),
      },
    },
    {
      id: "gradeBar",
      selector: ".activity-circle-current",
      highlightedSelectors: [".activity-circle-current"],
      mutationObservables: [".activity-circle-current"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          text="this_is_the_grade_for_this_activity"
          onNextClick={() => setCurrentStep(currentStep + 1)}
          audioLink="this_is_the_grade_for_this_activity"
          showAudio
          showNextButton
          showImage
          forceShow
          image={17}
          imagePosition="right"
          showBackButton
          onBackClick={() => setCurrentStep(currentStep - 1)}
          customImageStyle={{
            top: -190,
          }}
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "top",
      styles: popoverStyles,
    },
    {
      id: "gradeBar",
      selector: ".module-summary-info-grade",
      highlightedSelectors: [".module-summary-info-grade"],
      mutationObservables: [".module-summary-info-grade"],
      content: ({ setIsOpen, currentStep, setCurrentStep }) => (
        <GetStartedBuble
          text="this_is_the_grade_for_the_module"
          onNextClick={() => {
            setIsOpen(false)
            onNext()
          }}
          audioLink="this_is_the_grade_for_the_module"
          showAudio
          showNextButton
          showBackButton
          onBackClick={() => setCurrentStep(currentStep - 1)}
          showImage
          forceShow
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      styles: popoverStyles,
      position: "bottom",
    },
  ]
}

export const retakSteps = (onNext) => {
  return [
    {
      id: "retakes",
      selector: ".exercise-retakes",
      highlightedSelectors: [".exercise-retakes"],
      mutationObservables: [".exercise-retakes"],
      content: ({ setCurrentStep, currentStep, setIsOpen }) => (
        <GetStartedBuble
          textComponent={
            <Typography component={"span"}>
              <Trans i18nKey={"pay_attention_to_the_number_of_retakes"}>
                {t("pay_attention_to_the_number_of_retakes")}
              </Trans>{" "}
              <Typography component={"span"} fontWeight={"bold"}>
                <Trans i18nKey={"attemps"}>{t("attemps")}</Trans>
              </Typography>{" "}
              <Trans i18nKey={"that_you_have"}>{t("that_you_have")}</Trans>
            </Typography>
          }
          onNextClick={() => {
            setIsOpen(false)
            onNext()
          }}
          audioLink="pay_attention_to_the_number_of_retakes"
          showAudio
          showNextButton
          showImage
          image={15}
          customImageStyle={{
            top: -175,
          }}
          forceShow
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "top",
      showBadge: true,
      styles: popoverStyles,
    },
  ]
}

export const gradeWrong = (onNext) => {
  return [
    {
      id: "grade-wrong",
      selector: ".exercise-next",
      highlightedSelectors: [".exercise-next"],
      mutationObservables: [".exercise-next"],
      content: ({ setIsOpen }) => (
        <GetStartedBuble
          text="continue_to_the_next_activity"
          audioLink="continue_to_the_next_activity"
          showAudio
          showImage
          image={10}
          imagePosition="right"
          customImageStyle={{
            top: -165,
          }}
          showNextButton
          onNextClick={() => {
            setIsOpen(false)
            onNext()
          }}
          forceShow
          onSkipClick={() => {
            setIsOpen(false)
          }}
        />
      ),
      position: "right",
      styles: {
        ...popoverStyles,
      },
    },
  ]
}
